import {
  Grid,
  GridCell,
  Loading,
  SPACING_16,
  SpacingVertical
} from 'mailup-web-components'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import { cleanupCallback, initCallback } from './recoil/callbacks/callbacks'
import { pageState } from './recoil/state/page'

import ErrorFeedback from 'Components/ErrorFeedback'
import PageContainer from 'Components/PageContainer'
import CombinedStatisticsBlock from './components/CombinedStatisticsBlock'
import Header from './components/Header'
import SearchRecipient from './components/SearchRecipient/SearchRecipient'
import StartConditionBlock from './components/StartConditionBlock'
import StepsBlock from './components/StepsBlock/StepsBlock'

const WorkflowStatistics = () => {
  const { idWorkflow } = useParams()

  const { loading, loaded, error, severity } = useRecoilValue(pageState)

  const init = useRecoilCallback(initCallback, [])
  const cleanup = useRecoilCallback(cleanupCallback, [])

  useEffect(() => {
    idWorkflow && init(idWorkflow)

    return () => cleanup()
  }, [])

  const onReload = async () => {
    await cleanup()
    init(idWorkflow)
  }

  return (
    <>
      <Header />
      <Loading open={loading} />

      <PageContainer>
        <ErrorFeedback
          severity={severity}
          error={error}
          onClickReload={onReload}
        />
        {loaded && !error && (
          <>
            <SearchRecipient />
            <SpacingVertical variant={SPACING_16} />
            <StepsBlock />
            <Grid cols={12}>
              <GridCell span={8}>
                <CombinedStatisticsBlock />
              </GridCell>
              <GridCell span={4}>
                <StartConditionBlock />
              </GridCell>
            </Grid>
          </>
        )}
      </PageContainer>
    </>
  )
}

export default WorkflowStatistics
